import React from 'react';
import { t } from '../../../utils/i18n';
import DashboardPanel from '../components/DashboardPanel';
import GaBreakdownBarList from './GaBreakdownBarList';

export default function GaBreakdownCard({
  title,
  items,
  isLoading,
  metricKey = 'activeUsers',
  className = '',
}) {
  const hasData =
    !isLoading &&
    (items || []).some((row) => row.dimension && String(row.dimension).trim() !== '');

  return (
    <DashboardPanel
      title={title}
      className={`flex min-h-[280px] flex-col ${className}`}
      bodyClassName="flex flex-1 flex-col"
    >
      {isLoading ? (
        <p className="flex flex-1 items-center justify-center py-8 text-dark-text-secondary">
          {t('common.loading')}
        </p>
      ) : !hasData ? (
        <p className="flex flex-1 items-center justify-center py-8 text-dark-text-secondary">
          {t('dashboard.ga.noData')}
        </p>
      ) : (
        <GaBreakdownBarList items={items} metricKey={metricKey} showSessionsEvents t={t} />
      )}
    </DashboardPanel>
  );
}
